module.exports = __webpack_public_path__ + "static/img/app.2d8dd13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.jpg
// module id = FgPK
// module chunks = 1